module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_lp/mainvisual-bg-pc_a36584739903c116d903b2889bea7552.svg";